import { addScriptToHead } from "../helpers/helpers";

type scripts = [
  string,
  Promise<void|Error>
]

const loadBraintreeScripts = ($version = '3.79.1') => {
  const scripts: scripts[] = [
    ["client-v3", addScriptToHead(`https://js.braintreegateway.com/web/${$version}/js/client.min.js`, {defer: true})],
    ["data-collector-v3", addScriptToHead(`https://js.braintreegateway.com/web/${$version}/js/data-collector.min.js`, {defer: true})],
    ["3ds-v3", addScriptToHead(`https://js.braintreegateway.com/web/${$version}/js/three-d-secure.min.js`, {defer: true})],
    ["paypal-v3", addScriptToHead(`https://js.braintreegateway.com/web/${$version}/js/paypal.min.js`, {defer: true})],
    ["paypal-checkout-v3", addScriptToHead(`https://js.braintreegateway.com/web/${$version}/js/paypal-checkout.js`, {defer: true})]
  ];

  return scripts.map(([_,script]) => script);
};

export default loadBraintreeScripts;